import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(private http: HttpClient, private prefix: string, private suffix: string, private modules: string[]) {}
  getTranslation(lang: string): Observable<any> {
    const requests = this.modules.map((moduleName) => {
        return this.http.get(`${this.prefix}${lang}/${moduleName}${this.suffix}`);
      });
  
      return forkJoin(requests).pipe(
        map((response: any[]) => {
          return response.reduce((acc, current) => {
            return { ...acc, ...current };
          }, {});
        })
      );
  }
}
